(function () {
  //  Guard 
  if (window.PACKSCLUB_LOCATION_INITIALIZED) return;
  window.PACKSCLUB_LOCATION_INITIALIZED = true;

  //  Constants 
  var STORAGE_KEY = 'packsclub_location';
  var BASE_URL    = 'https://www.packsclub.com/menu';
  /* var BASE_URL = 'https://menus.dispenseapp.com'; */


  var SLUG_TO_PAGE = {
    'san-gabriel-valley': '/pages/san-gabriel-valley',
    'south-los-angeles':  '/pages/south-los-angeles',
    'orange-county':      '/pages/orange-county',
    'san-bernardino':     '/pages/san-bernardino',
  };
  var LOCATION_PAGE_FALLBACK = '/pages/san-gabriel-valley';

  var BLOCKED_MODAL_PATHS = [
    '/pages/wholesale',
    '/collections/wholesale',
    '/collections/retail-supplies',
    '/collections/w-merch-apparel',
    '/collections/staff-onboarding',
    '/collections/w-special-events',
    '/pages/packs-hollywood-grand-opening',
    '/pages/grand-opening-soon',
    '/pages/909-landing-page',
  ];

  function isModalBlockedPath() {
    var currentPath = window.location.pathname.toLowerCase();
    var isProductPage = currentPath.indexOf('/products/') === 0;

    return isProductPage || BLOCKED_MODAL_PATHS.some(function (path) {
      return currentPath === path.toLowerCase();
    });
  }


  //  State 
  var updateUITimeout    = null;
  var observerDebounce   = null;
  var modalListenersBound = false; // prevent double-binding modal item clicks

  //  Storage helpers 
  // Wrap localStorage in try/catch — Safari private mode throws on access
  function storageGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function storageSet(key, val) {
    try { localStorage.setItem(key, val); } catch (e) {}
  }
  function storageRemove(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }
  function sessionGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function sessionSet(key, val) {
    try { sessionStorage.setItem(key, val); } catch (e) {}
  }

  function getLocation() {
    return storageGet(STORAGE_KEY);
  }

  //  UI helpers ──
  function toDisplayText(slug) {
    return slug.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function highlightActiveLocation() {
    var current = getLocation();
    document.querySelectorAll('.location-item').forEach(function (btn) {
      var isActive = current && btn.dataset.location === current;
      btn.classList.toggle('is-active', !!isActive);
      if (isActive) {
        btn.setAttribute('data-selected', 'true');
      } else {
        btn.removeAttribute('data-selected');
      }
    });
  }

  var SLUG_TO_VENUE = {
    'san-gabriel-valley': '998fff4d8f02c2fa',
    'south-los-angeles':  'e954a82c8f72a4e2',
    'orange-county':      '9a0a86a6a5bb3cde',
    'san-bernardino':     '537b23523e4ab8cc',
  };

  /*  when shop links are broken
  function updateShopLinks() {
    var current = getLocation();
    if (!current) return;
    var venueId = SLUG_TO_VENUE[current] || current;
    document.querySelectorAll('#dynamic-shop-link').forEach(function (el) {
      var anchor = el.closest('a') || el;
      anchor.href = BASE_URL + '/' + venueId + '/menu';
    });
  } */

  // ── UTM Auto-Location Detection ──────────────────────────────────────────────
  // Reads utm_source=gmb-{slug} and silently pre-sets the location.
  // Does NOT override an existing localStorage choice.
  // Does NOT open the modal or redirect — just sets silently.
  function maybeSetLocationFromUTM() {
    try {
      var params = new URLSearchParams(window.location.search);
      var source  = params.get('utm_source') || '';

      // Match gmb-{slug} pattern
      var match = source.match(/^gmb-(.+)$/);
      if (!match) return;

      // Also check for ?location="" directly
      var directSlug = params.get('location');
      if (directSlug && SLUG_TO_PAGE[directSlug] && !getLocation()) {
        storageSet(STORAGE_KEY, directSlug);
        sessionSet('location_acknowledged', 'true');
        sessionSet('location_modal_dismissed', 'true');
        return;
      }

      var slug = match[1]; // e.g. "san-gabriel-valley"

      // Validate against known slugs — never silently set an unknown location
      if (!SLUG_TO_PAGE[slug]) {
        console.warn('[PACKS] UTM slug not recognized:', slug);
        return;
      }

      // Only auto-set if user has NO existing location preference
      // (respect returning visitors who already chose a different store)
      //if (!getLocation()) {
        storageSet(STORAGE_KEY, slug);
        sessionSet('location_acknowledged', 'true');
        sessionSet('location_modal_dismissed', 'true'); // suppress the modal
        console.log('[PACKS] Location auto-set from UTM:', slug);
      //}
    } catch (e) {}
  }

  
  function updateShopLinks() {
    var current = getLocation();
    if (!current) return;
    document.querySelectorAll('#dynamic-shop-link').forEach(function (el) {
      var anchor = el.closest('a') || el;
      anchor.href = BASE_URL + '/' + current;
    });
  } 

  function updateLocationLink(slug) {
    var link = document.getElementById('nav-location-link');
    if (!link) return;
    link.href = SLUG_TO_PAGE[slug] || LOCATION_PAGE_FALLBACK;
  }

  function updateSelectedTitles() {
    var current = getLocation();
    document.querySelectorAll('.pickup-card').forEach(function (card) {
      var title = card.querySelector('[data-store-name]');
      if (!title) return;
      var original = title.textContent.replace(' (SELECTED)', '');
      title.textContent = current && card.dataset.location === current
        ? original + ' (SELECTED)'
        : original;
    });
  }

  function syncPickupLocations() {
    var current = getLocation();
    if (!current) return;
    var cards = document.querySelectorAll('.pickup-card');
    cards.forEach(function (card) {
      card.classList.toggle('is-active', card.dataset.location === current);
    });
    updateSelectedTitles();
  }

  //  updateUI ─
  // Debounced — safe to call repeatedly from MutationObserver
  function updateUI(force) {
    if (!force && updateUITimeout) return;
    if (updateUITimeout) { clearTimeout(updateUITimeout); updateUITimeout = null; }

    var current = getLocation();
    var labels  = document.querySelectorAll('#current-location-label');
    var triggerText = document.getElementById('location-trigger-text');

    if (!labels.length && !triggerText && !force) {
      updateUITimeout = setTimeout(function () { updateUITimeout = null; updateUI(true); }, 50);
      return;
    }

    if (!current) {
      labels.forEach(function (label) {
        label.textContent = 'Select Location ⚠️';
        label.classList.add('location-required-label');
        label.removeAttribute('data-location-set');
      });
      if (triggerText) {
        triggerText.textContent = 'Select Location';
      }
      document.querySelectorAll('.location-item').forEach(function (btn) {
        btn.removeAttribute('data-selected');
        btn.classList.remove('is-active');
      });
    } else {
      document.body.classList.remove('location-required');
      var displayText = toDisplayText(current);
      labels.forEach(function (label) {
        label.textContent = displayText;
        label.classList.remove('location-required-label');
        label.setAttribute('data-location-set', 'true');
      });
      if (triggerText) {
        triggerText.textContent = displayText;
      }
      highlightActiveLocation();
      updateShopLinks();
      updateLocationLink(current);
    }
  }

  //  Modal 
  function openLocationModal() {
    var modal = document.getElementById('location-modal');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');

    // iOS Safari: prevent background scroll properly
    var scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top      = '-' + scrollY + 'px';
    document.body.style.width    = '100%';
    document.body.dataset.scrollY = scrollY;
  }

  function closeLocationModal() {
    var modal = document.getElementById('location-modal');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');

    // Restore scroll position on iOS Safari
    var scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.width    = '';
    window.scrollTo(0, scrollY);

    if (!getLocation()) {
      sessionSet('location_modal_dismissed', 'true');
    }
  }

  function maybeOpenLocationModal() {
    if (isModalBlockedPath()) return;

    var hasLocation = getLocation();
    var dismissed   = sessionGet('location_modal_dismissed');
    if (!hasLocation && !dismissed) {
      setTimeout(openLocationModal, 300);
    }
  }


  //  setLocation ─
  function setLocation(slug) {
    storageSet(STORAGE_KEY, slug);
    sessionSet('location_acknowledged', 'true');
    updateUI(true);
    highlightActiveLocation();
    updateLocationLink(slug);
    closeLocationModal();
    syncPickupLocations();

    // Notify other sections (AIQ loader, etc.)
    document.dispatchEvent(new CustomEvent('packsclub:location-changed', { detail: { slug: slug } }));
  }

  //  Event listeners 
  function setupEventListeners() {

    // ── 1. Location toggle buttons → open modal ──
    // Use single delegated listener — avoids clone/replace pattern
    document.addEventListener('click', function (e) {
      if (e.target.closest('.location-toggle')) {
        e.preventDefault();
        e.stopPropagation();
        openLocationModal();
      }
    });

    // ── 2. [data-location-trigger] → open modal 
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-location-trigger]')) {
        e.preventDefault();
        e.stopPropagation();
        openLocationModal();
      }
    });

    // ── 3. Location item selection (modal + any inline pickers) ──
    // Bound ONCE via delegation — no clone/replace needed
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.location-item');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var slug = btn.dataset.location;
      if (!slug) return;

      setLocation(slug);

      // Optional: scroll to pickup card on homepage
      if (btn.dataset.scroll === 'true') {
        if (window.location.pathname === '/') {
          syncPickupLocations();
        } else {
          storageSet('scroll_to_pickup', 'true');
        }
      }
    });

    // ── 4. Category links ─
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.category-link');
      if (!link) return;
      var category = link.dataset.category;
      if (!category) return;
      var location = getLocation();
      if (!location) {
        e.preventDefault();
        e.stopPropagation();
        storageSet('pending_category', category);
        openLocationModal();
        return;
      }
        link.href = BASE_URL + '/' + location + '/categories/' + category;
        var venueId = SLUG_TO_VENUE[location] || location;
       /*  link.href = BASE_URL + '/' + venueId + '/menu/categories/' + category;*/ 

    });

    // ── 5. Modal overlay click → close 
    // Bound here, after DOM is ready — fixes the Safari parse-time null bug
    document.addEventListener('click', function (e) {
      if (e.target.closest('.location-modal__overlay') &&
          !e.target.closest('.location-modal__content')) {
        closeLocationModal();
      }
    });

    // ── 6. Escape key → close modal 
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) &&
          document.getElementById('location-modal')?.getAttribute('aria-hidden') === 'false') {
        closeLocationModal();
      }
    });

    // ── 7. Cross-tab location sync (other tabs / windows) ──
    window.addEventListener('storage', function (e) {
      if (e.key !== STORAGE_KEY || !e.newValue) return;
      updateUI(true);
      highlightActiveLocation();
      updateLocationLink(e.newValue);
      updateShopLinks();
    });
  }

  //  MutationObserver ──
  // Watches only the specific elements we care about, not the whole body.
  // Falls back to body observation if targets aren't found yet.
  function setupObserver() {
    var labelEl    = document.getElementById('current-location-label');
    var shopLinkEl = document.getElementById('dynamic-shop-link');

    // If neither target exists yet, observe body childList shallowly
    // and re-run when they appear
    if (!labelEl && !shopLinkEl) {
      var bodyObserver = new MutationObserver(function (mutations, obs) {
        var found = document.getElementById('current-location-label') ||
                    document.getElementById('dynamic-shop-link');
        if (found) {
          obs.disconnect();
          setupObserver(); // retry now that targets exist
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
      return;
    }

    var targets = [];
    if (labelEl)    targets.push(labelEl.parentElement || labelEl);
    if (shopLinkEl) targets.push(shopLinkEl.parentElement || shopLinkEl);

    var observer = new MutationObserver(function () {
      if (observerDebounce) clearTimeout(observerDebounce);
      observerDebounce = setTimeout(function () {
        observerDebounce = null;
        updateUI(true);
        highlightActiveLocation();
        syncPickupLocations();
      }, 0);
    });

    targets.forEach(function (target) {
      observer.observe(target, {
        childList:     true,
        subtree:       true,
        characterData: true,
        // NOTE: NO attributes:true — avoids observer storm from hover/animation class toggles
      });
    });
  }

  //  Init ─
  function init() {
    maybeSetLocationFromUTM();
    updateUI();
    highlightActiveLocation();
    setupEventListeners();
    maybeOpenLocationModal();
    setupObserver();

    // Handle cross-page scroll-to-pickup intent
    if (storageGet('scroll_to_pickup')) {
      storageRemove('scroll_to_pickup');
      syncPickupLocations();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();